import { addUserOrgSpace } from './Decorators.es6';
import { omit } from 'lodash';

// Props we send to Segment but want to omit from Snowplow payload.
// We include this information with `addUserOrgSpace`
const SEGMENT_PROPS = ['userId', 'spaceId', 'organizationId', 'currentState'];

export default addUserOrgSpace((_, data) => {
  return { data: omit(data, SEGMENT_PROPS) };
});



// WEBPACK FOOTER //
// ./src/javascripts/analytics/snowplow/transformers/WebhookEditor.es6.js